export const BASE_AUTH = process.env.REACT_APP_BASE_AUTH
export const BASE_DATA = process.env.REACT_APP_BASE_DATA
export const BASE_CDN = process.env.REACT_APP_BASE_CDN

export const REFRESH_PATH_END = process.env.REACT_APP_REFRESH_PATH_END


